import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

export const fetchCurrencyRequestAction = action(
  async (
    ctx,
    { address, network }: { network: Network.Network; address: string },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesGetTokenMetaList, [
        {
          network: Network.toDto(network),
          token: address,
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchCurrencyRequestAction',
)
